import React from 'react';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './ReactionButton.scss';
const ReactionButton = ({ iconUrl , text , onClick  })=>{
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['root'],
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement("img", {
        src: iconUrl,
        alt: text
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, text));
};
ReactionButton.displayName = 'ReactionButton';
export default ReactionButton;
